import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
import type { IVideoSectionProps } from '../../interfaces';

export const VideoSection = ({
  url,
  jobPostData,
  videoRef,
  isPlaying,
  handlePlayPause,
}: IVideoSectionProps) => {
  if (!url) return null;

  return (
    <Box sx={{ mb: 3 }}>
      {jobPostData?.videoTitle && (
        <Typography variant="h3" sx={{ mb: 1 }}>
          {jobPostData.videoTitle}
        </Typography>
      )}
      {jobPostData?.videoDescription && (
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {jobPostData.videoDescription}
        </Typography>
      )}
      <Box sx={{ bgcolor: 'grey.100', borderRadius: 3, p: 2, border: 1, borderColor: 'divider' }}>
        <Box
            component="video"
            ref={videoRef}
            controls
            preload="metadata"
            playsInline
            sx={{ width: '100%', borderRadius: 2, mb: 1.5, bgcolor: 'common.black' }}
        >
          <source src={url} type="video/mp4" />
          Your browser does not support the video tag.
        </Box>
        <Button
            onClick={handlePlayPause}
            variant="contained"
            fullWidth
            startIcon={isPlaying ? <PauseIcon fontSize="small" /> : <PlayArrowIcon fontSize="small" />}
        >
          {isPlaying ? 'Pause' : 'Play'}
        </Button>
      </Box>
    </Box>
  );
};
